import { render, staticRenderFns } from "./ClassesDetail.vue?vue&type=template&id=da818a22&scoped=true&"
import script from "./ClassesDetail.vue?vue&type=script&lang=js&"
export * from "./ClassesDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetail.vue?vue&type=style&index=0&id=da818a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da818a22",
  null
  
)

export default component.exports